import React from "react";
import {
  SectionBox,
  SectionTitle,
  SectionArticle,
  SectionRemark,
  SectionMentWrapper,
} from "./unit";
import { ARTICLES } from "../asset/article";
import { IMAGE_INFO } from "./constant";
export function Section({ title = null, article, remark = null }) {
  return (
    <SectionBox>
      {title &&
        title.map((text, idx) => {
          return <SectionTitle key={`title-${idx}`}>{text}</SectionTitle>;
        })}
      {article.map((text, idx) => {
        return <SectionArticle key={`article-${idx}`}>{text}</SectionArticle>;
      })}
      {remark &&
        remark.map((text, idx) => {
          return <SectionRemark key={`remark-${idx}`}>{text}</SectionRemark>;
        })}
    </SectionBox>
  );
}

export function SectionFourth() {
  return (
    <SectionBox>
      <SectionTitle>{ARTICLES.section4.title}</SectionTitle>
      <SectionMentWrapper>
        <div className="wrap">
          <span className="ment">
            “백이면 백 다 인도로 올라옵니다.
            <br />
            살고싶어서”
          </span>
          <span className="name">대림대학교 미래자동차학부 김필수 교수</span>
        </div>
        <div className="wrap-img">
          <img src={IMAGE_INFO.rightman1.src} alt={IMAGE_INFO.rightman1.alt} />
        </div>
      </SectionMentWrapper>

      <SectionArticle>{ARTICLES.section4.text[0]}</SectionArticle>
      <SectionMentWrapper>
        <div className="wrap-img">
          <img src={IMAGE_INFO.leftman1.src} alt={IMAGE_INFO.leftman1.alt} />
        </div>
        <div className="wrap">
          <span className="ment">“자전거 도로도 위험합니다”</span>
          <span className="name">차두원모빌리티연구소 차두원 소장*</span>
        </div>
      </SectionMentWrapper>

      <SectionArticle>{ARTICLES.section4.text[1]}</SectionArticle>
      <SectionMentWrapper>
        <div className="wrap">
          <span className="ment">“새로운 도로가 필요합니다”</span>
          <span className="name"> 한국교통연구원 신희철 본부장</span>
        </div>
        <div className="wrap-img">
          <img src={IMAGE_INFO.rightman1.src} alt={IMAGE_INFO.rightman1.alt} />
        </div>
      </SectionMentWrapper>
      <SectionArticle>{ARTICLES.section4.text[2]}</SectionArticle>
    </SectionBox>
  );
}
